import { render } from "./SliderImg.vue?vue&type=template&id=04ea3adc&scoped=true"
import script from "./SliderImg.vue?vue&type=script&lang=js"
export * from "./SliderImg.vue?vue&type=script&lang=js"

import "./SliderImg.vue?vue&type=style&index=0&id=04ea3adc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ea3adc"]])

export default __exports__